module.exports = __webpack_public_path__ + "img/background-video-slider-honda.c6b259c5.jpg";